<template>
  <div class="begin">
    <div class="pb-0">
      <Header :isHome="false" :driverData="[]" />
    </div>

    <!-- Hero -->
    <div class="hackathon-hero">
      <div class="hackathon-hero-content">

        <!-- Badge prize -->
        <div class="hero-prize-badge">
          <span class="badge-pills">
            <span class="badge-pill badge-pill--trophy">🏆</span>
            <span class="badge-pill badge-pill--btc">
              <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.43003 3.73482C5.20043 4.65392 3.79944 4.18234 3.34436 4.07029L3.74651 2.46239C4.19403 2.57237 5.65964 2.7841 5.42316 3.73482H5.43003ZM5.17912 6.33332C4.93096 7.33422 3.24537 6.79253 2.69886 6.6571L3.14226 4.88146C3.68877 5.01895 5.43897 5.28773 5.17912 6.33332ZM7.01663 3.74857C7.16099 2.77036 6.41719 2.24447 5.40872 1.89525L5.73938 0.569882L4.92408 0.367777L4.60236 1.65878C4.39132 1.60584 4.17272 1.55566 3.95686 1.50685L4.27858 0.202105L3.47222 0L3.14157 1.32537L2.62737 1.21057L1.51373 0.932847L1.29994 1.7942C1.29994 1.7942 1.85676 1.93031 1.88563 1.94131C2.06574 1.97774 2.28022 2.1716 2.26234 2.40052L1.35699 6.02948C1.3075 6.18415 1.14251 6.26939 0.987154 6.21989C0.969968 6.21508 0.399398 6.07553 0.399398 6.07553L0 6.99463L1.04971 7.25448L1.62372 7.40365L1.291 8.74277L2.09736 8.94488L2.42801 7.61951C2.64524 7.67932 2.85903 7.73431 3.0687 7.78518L2.74286 9.11536L3.54922 9.31541L3.88193 7.97904C5.26024 8.23888 6.29139 8.13508 6.72791 6.89014C7.07918 5.88855 6.70935 5.31248 5.98617 4.93577C6.51343 4.81272 6.90389 4.47519 7.01663 3.74857Z" fill="url(#paint0_linear_2916_202)"/><defs><linearGradient id="paint0_linear_2916_202" x1="-1.54347" y1="9.92147" x2="-1.1647" y2="-0.210858" gradientUnits="userSpaceOnUse"><stop stop-color="#FF9211"/></linearGradient></defs></svg>
            </span>
            <span class="badge-pill badge-pill--lightning">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>
            </span>
          </span>
          <span class="badge-text">+1M XOF versé en prize</span>
        </div>

        <!-- Titre -->
        <h1 class="hero-title">
          <span class="title-bitcoin">Bitcoin</span>
          <span class="title-hackathon"> Hackathon</span>
        </h1>

        <!-- Accroche -->
        <p class="hero-hook">Construis le futur de la monnaie en Afrique.</p>
        <p class="hero-desc">
          Rejoins le hackathon du Bitcoin Mastermind et crée des solutions<br class="br-desktop"/>
          pour l'Afrique avec Bitcoin.
        </p>

        <!-- CTAs -->
        <div class="hero-actions">
          <router-link to="/hackathon/apply" class="btn-join">Rejoindre l'aventure</router-link>
          <div class="btn-date">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
            29 – 01 Juillet 2026
          </div>
        </div>

        <!-- Stats card -->
        <div class="hero-stats-card">
          <div class="stats-label">
            <span class="stats-dot"></span>
            Statistiques 2025
          </div>
          <div class="stats-divider"></div>
          <div class="stats-items-group">
            <div class="stats-item">
              <span class="stats-number">30+</span>
              <span class="stats-desc">Participants</span>
            </div>
            <div class="stats-sep"></div>
            <div class="stats-item">
              <span class="stats-number">6+</span>
              <span class="stats-desc">Projets</span>
            </div>
            <div class="stats-sep"></div>
            <div class="stats-item">
              <span class="stats-number">3+</span>
              <span class="stats-desc">Gagnants</span>
            </div>
            <div class="stats-sep"></div>
            <div class="stats-item">
              <span class="stats-number">1M+</span>
              <span class="stats-desc">XOF en Bitcoin</span>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- Pourquoi participer -->
      <section class="section-why">
        <div class="why-container">
          <h2 class="why-title">Pourquoi participer ?</h2>
          <p class="why-subtitle">Une opportunité unique de contribuer à l'écosystème Bitcoin africain</p>
          <div class="why-grid">

            <div class="why-card why-card--peach">
              <div class="why-icon-wrap why-icon-wrap--peach">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#FF9211" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/>
                </svg>
              </div>
              <h3 class="why-card-title">Découverte</h3>
              <p class="why-card-desc">Explorez les technologies Bitcoin et leurs applications pour l'Afrique</p>
            </div>

            <div class="why-card why-card--green">
              <div class="why-icon-wrap why-icon-wrap--green">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#42D786" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
                </svg>
              </div>
              <h3 class="why-card-title">Impact Local</h3>
              <p class="why-card-desc">Créez des solutions adaptées aux défis africains des paiements, épargnes et remittances</p>
            </div>

            <div class="why-card why-card--cream">
              <div class="why-icon-wrap why-icon-wrap--cream">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#FBDB6C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                </svg>
              </div>
              <h3 class="why-card-title">Collaboration</h3>
              <p class="why-card-desc">Travaillez en équipe avec des développeurs, designers et entrepreneurs</p>
            </div>

            <div class="why-card why-card--orange">
              <div class="why-icon-wrap why-icon-wrap--orange">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#FF9211" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"/><path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"/><path d="M4 22h16"/><path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"/><path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"/><path d="M18 2H6v7a6 6 0 0 0 12 0V2z"/>
                </svg>
              </div>
              <h3 class="why-card-title">Visibilité</h3>
              <p class="why-card-desc">Présentez vos projets devant un jury d'experts et gagnez des prix</p>
            </div>

          </div>
        </div>
      </section>

    <!-- Technologies Bitcoin -->
      <section class="section-tech">
        <div class="tech-container">
          <h2 class="tech-title">Technologies Bitcoin</h2>
          <p class="tech-subtitle">Découvrez et maîtrisez les outils les plus avancés de l'écosystème Bitcoin</p>

          <div class="tech-grid" style="display: grid; grid-template-columns: 412px 412px 412px; gap: 20px; margin: 0 auto 56px auto; max-width: 1280px; width: 100%;">
            <div class="tech-card" style="position: relative; width: 412px; max-width: 412px; height: 266px; background: #FFFFFF; border-radius: 10px; padding: 25px 23px; display: flex; flex-direction: column; gap: 0; box-sizing: border-box;">
              <div class="tech-card-header">
                <img :src="bdkLogo" width="65" height="65" alt="Bitcoin Dev Kit" class="tech-logo-img"/>
                <span class="tech-name">Bitcoin Dev Kit</span>
              </div>
              <p class="tech-desc">Toolkit pour construire des portefeuilles Bitcoin</p>
              <a href="#" class="tech-link">En savoir plus <span><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="16" height="16" fill="#42D786"/>
<path d="M3.3335 8H12.6668" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8 3.33301L12.6667 7.99967L8 12.6663" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</span></a>
            </div>

            <div class="tech-card" style="position: relative; width: 412px; max-width: 412px; height: 266px; background: #FFFFFF; border-radius: 10px; padding: 25px 23px; display: flex; flex-direction: column; gap: 0; box-sizing: border-box;">
              <div class="tech-card-header">
                <img :src="ldkLogo" width="65" height="65" alt="Lightning Dev Kit" class="tech-logo-img"/>
                <span class="tech-name">Lightning Dev Kit</span>
              </div>
              <p class="tech-desc">Infrastructure pour le Lightning Network</p>
              <a href="#" class="tech-link">En savoir plus <span><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="16" height="16" fill="#42D786"/>
<path d="M3.3335 8H12.6668" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8 3.33301L12.6667 7.99967L8 12.6663" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</span></a>
            </div>

            <div class="tech-card" style="position: relative; width: 412px; max-width: 412px; height: 266px; background: #FFFFFF; border-radius: 10px; padding: 25px 23px; display: flex; flex-direction: column; gap: 0; box-sizing: border-box;">
              <div class="tech-card-header">
                <img :src="flashLogo" width="65" height="65" alt="Flash Sandbox" class="tech-logo-img"/>
                <span class="tech-name">Flash Sandbox</span>
              </div>
              <p class="tech-desc">Outil d'intégration de paiements transfrontaliers en Afrique</p>
              <a href="#" class="tech-link">En savoir plus <span><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="16" height="16" fill="#42D786"/>
<path d="M3.3335 8H12.6668" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8 3.33301L12.6667 7.99967L8 12.6663" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</span></a>
            </div>

            <div class="tech-card" style="position: relative; width: 412px; max-width: 412px; height: 266px; background: #FFFFFF; border-radius: 10px; padding: 25px 23px; display: flex; flex-direction: column; gap: 0; box-sizing: border-box;">
              <div class="tech-card-header">
                <img :src="wdkLogo" width="65" height="65" alt="Wallet Development Kit" class="tech-logo-img"/>
                <span class="tech-name">Wallet Development Kit</span>
              </div>
              <p class="tech-desc">Outil de développement de portefeuille Bitcoin &amp; Stablecoins</p>
              <a href="#" class="tech-link">En savoir plus <span><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="16" height="16" fill="#42D786"/>
<path d="M3.3335 8H12.6668" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8 3.33301L12.6667 7.99967L8 12.6663" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</span></a>
            </div>

            <div class="tech-card" style="position: relative; width: 412px; max-width: 412px; height: 266px; background: #FFFFFF; border-radius: 10px; padding: 25px 23px; display: flex; flex-direction: column; gap: 0; box-sizing: border-box;">
              <div class="tech-card-header">
                <img :src="blinkLogo" width="65" height="65" alt="Blink API" class="tech-logo-img"/>
                <span class="tech-name">Blink API</span>
              </div>
              <p class="tech-desc">Solution d'intégration des paiements Bitcoin et Lightning</p>
              <a href="#" class="tech-link">En savoir plus <span><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="16" height="16" fill="#42D786"/>
<path d="M3.3335 8H12.6668" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8 3.33301L12.6667 7.99967L8 12.6663" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</span></a>
            </div>

            <div class="tech-card" style="position: relative; width: 412px; max-width: 412px; height: 266px; background: #FFFFFF; border-radius: 10px; padding: 25px 23px; display: flex; flex-direction: column; gap: 0; box-sizing: border-box;">
              <div class="tech-card-header">
                <img :src="lnbitsLogo" width="65" height="65" alt="LNbits" class="tech-logo-img"/>
                <span class="tech-name">LNbits</span>
              </div>
              <p class="tech-desc">Toolkit pour construire des portefeuilles Bitcoin</p>
              <a href="#" class="tech-link">En savoir plus <span><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="16" height="16" fill="#42D786"/>
<path d="M3.3335 8H12.6668" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8 3.33301L12.6667 7.99967L8 12.6663" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</span></a>
            </div>
          </div>


          <div class="tech-more">
            <p class="tech-more-title">Plus encore</p>
            <div class="tech-more-wrapper">
              <div class="tech-badges">
                <span class="tech-badge"><img :src="albyLogo" width="20" height="20" alt="Alby" class="badge-icon"/>Alby</span>
                <span class="tech-badge"><img :src="fedimintLogo" width="20" height="20" alt="Fedimint" class="badge-icon"/>Fedimint</span>
                <span class="tech-badge"><img :src="cashuLogo" width="20" height="20" alt="Cashu" class="badge-icon"/>Cashu</span>
                <span class="tech-badge"><img :src="lnurlLogo" width="20" height="20" alt="LNURL" class="badge-icon"/>LNURL</span>
                <span class="tech-badge"><img :src="weblnLogo" width="20" height="20" alt="WebLN" class="badge-icon"/>WebLN</span>
                <span class="tech-badge"><img :src="nostrLogo" width="20" height="20" alt="Nostr" class="badge-icon"/>Nostr</span>
                <span class="tech-badge"><img :src="rgbLogo" width="20" height="20" alt="RGB" class="badge-icon"/>RGB</span>
                <span class="tech-badge"><img :src="bitnobLogo" width="20" height="20" alt="Bitnob" class="badge-icon"/>Bitnob</span>
              </div>
              <div class="tech-more-border"></div>
            </div>
          </div>

        </div>
      </section>

    <!-- Agenda -->
      <section class="section-agenda" id="participer">
        <div class="agenda-container">

          <h2 class="agenda-title">Agenda du <span class="agenda-title--orange">Hackathon</span></h2>
          <p class="agenda-subtitle">Un parcours structuré de l'apprentissage à l'innovation</p>

          <div class="agenda-grid">

            <div class="agenda-col">
              <div class="agenda-day-badge agenda-day-badge--yellow">● Jour 1</div>
              <div class="agenda-day-heading">29 Juin <span>Ateliers & Formation</span></div>
              <p class="agenda-day-sub">Immersion totale dans l'écosystème Bitcoin</p>
              <ul class="agenda-list">
                <li><span class="agenda-dot agenda-dot--green"></span>Accueil &amp; présentation</li>
                <li><span class="agenda-dot agenda-dot--yellow"></span>Sessions techniques : Les outils</li>
                <li><span class="agenda-dot agenda-dot--yellow"></span>Ateliers : Les bases de Bitcoin</li>
                <li><span class="agenda-dot agenda-dot--yellow"></span>Formation des équipes</li>
              </ul>
            </div>

            <div class="agenda-col agenda-col--border">
              <div class="agenda-day-badge agenda-day-badge--green">● Jour 2</div>
              <div class="agenda-day-heading">30 Juin <span>Prototypage</span></div>
              <p class="agenda-day-sub">Transformation des idées en réalité</p>
              <ul class="agenda-list">
                <li><span class="agenda-dot agenda-dot--green"></span>Idéation &amp; brainstorming</li>
                <li><span class="agenda-dot agenda-dot--green"></span>Développement des projets</li>
                <li><span class="agenda-dot agenda-dot--green"></span>Mentoring technique</li>
                <li><span class="agenda-dot agenda-dot--green"></span>Sessions de feedback</li>
              </ul>
            </div>

            <div class="agenda-col agenda-col--border">
              <div class="agenda-day-badge agenda-day-badge--orange">● Jour 3</div>
              <div class="agenda-day-heading">01 Juillet <span>Développement</span></div>
              <p class="agenda-day-sub">Développement et finalisation</p>
              <ul class="agenda-list">
                <li><span class="agenda-dot agenda-dot--orange"></span>Finalisation des projets</li>
                <li><span class="agenda-dot agenda-dot--orange"></span>Premières présentations</li>
                <li><span class="agenda-dot agenda-dot--orange"></span>Feedbacks pour amélioration</li>
                <li><span class="agenda-dot agenda-dot--orange"></span>Présentation + Prix au Dev Day</li>
              </ul>
            </div>

          </div>

          <div class="agenda-cta-wrap">
            <router-link to="/hackathon/apply" class="agenda-cta">Rejoignez l'aventure</router-link>
          </div>

        </div>
      </section>

    <!-- Prix -->
      <section class="section-prizes">
        <div class="prizes-container">

          <h2 class="prizes-title"><span class="prizes-title--orange">Prix</span> &amp; récompenses</h2>
          <p class="prizes-subtitle">Des récompenses exceptionnelles pour reconnaître votre talent et<br/>votre innovation</p>

          <div class="prizes-grid">

            <div class="prize-card">
              <div class="prize-badge-top">🏆 Grand Prix</div>
              <div class="prize-icon prize-icon--gold">
                <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"/><path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"/><path d="M4 22h16"/><path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"/><path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"/><path d="M18 2H6v7a6 6 0 0 0 12 0V2z"/></svg>
              </div>
              <h3 class="prize-name">1er Prix</h3>
              <p class="prize-award"><span class="prize-award-dot prize-award-dot--orange"></span>Satoshi Award</p>
              <p class="prize-amount prize-amount--orange">500,000 FCFA</p>
            </div>

            <div class="prize-card">
              <div class="prize-icon prize-icon--green">
                <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="6"/><path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11"/></svg>
              </div>
              <h3 class="prize-name">2ème Prix</h3>
              <p class="prize-award"><span class="prize-award-dot prize-award-dot--green"></span>Lightning Award</p>
              <p class="prize-amount prize-amount--green">300,000 FCFA</p>
            </div>

            <div class="prize-card">
              <div class="prize-icon prize-icon--yellow">
                <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>
              </div>
              <h3 class="prize-name">3ème Prix</h3>
              <p class="prize-award"><span class="prize-award-dot prize-award-dot--yellow"></span>Block Award</p>
              <p class="prize-amount prize-amount--yellow">150,000 FCFA</p>
            </div>

            <div class="prize-card">
              <div class="prize-icon prize-icon--dark">
                <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
              </div>
              <h3 class="prize-name">Prix Spéciaux</h3>
              <p class="prize-award prize-award--gray">Mentions honorifiques</p>
              <p class="prize-amount prize-amount--dark">Surprises</p>
            </div>

          </div>

          <h3 class="prizes-more-title">Mais ce n'est pas tout !</h3>
          <p class="prizes-more-sub">Des avantages supplémentaires qui feront la différence dans votre carrière</p>

          <div class="prizes-bonus-card">
            <span class="bonus-item"><span class="bonus-dot"></span>Bourse d'étude d'entrée à la Plan B Business / Tech School</span>
            <span class="bonus-item"><span class="bonus-dot"></span>Mentorat personnalisé avec des experts Bitcoin</span>
            <span class="bonus-item"><span class="bonus-dot"></span>Opportunités de stage, d'emploi et d'incubation</span>
            <span class="bonus-item"><span class="bonus-dot"></span>Certification de participation officielle</span>
            <span class="bonus-item"><span class="bonus-dot"></span>Réseau professionnel étendu</span>
            <span class="bonus-item"><span class="bonus-dot"></span>Formation continue post-hackathon</span>
          </div>

        </div>
      </section>

    <!-- Partenaires -->
      <PartnersHackathon />

    <!-- Témoignages -->
      <TestimonialsHackathon />

    <!-- FAQ -->
      <FaqHackathon />

    <HackathonFooter />
  </div>
</template>

<script>
import Header from "@/components/header/index.vue"
import HackathonFooter from "@/components/container/hackathon/hackathon-footer.vue"
import PartnersHackathon from "@/components/container/hackathon/partners-hackathon.vue"
import TestimonialsHackathon from "@/components/container/hackathon/testimonials-hackathon.vue"
import FaqHackathon from "@/components/container/hackathon/faq-hackathon.vue"
import bdkLogo from "@/assets/tech/bdk.svg"
import ldkLogo from "@/assets/tech/ldk.svg"
import flashLogo from "@/assets/tech/flash.svg"
import wdkLogo from "@/assets/tech/wdk.svg"
import blinkLogo from "@/assets/tech/blink.svg"
import lnbitsLogo from "@/assets/tech/lnbits.svg"
import albyLogo from "@/assets/tech/alby.svg"
import fedimintLogo from "@/assets/tech/fedimint.svg"
import cashuLogo from "@/assets/tech/cashu.svg"
import lnurlLogo from "@/assets/tech/lnurl.svg"
import weblnLogo from "@/assets/tech/webln.svg"
import nostrLogo from "@/assets/tech/nostr.svg"
import rgbLogo from "@/assets/tech/rgb.svg"
import bitnobLogo from "@/assets/tech/bitnob.svg"

export default {
  name: "HackathonPage",
  components: {
    Header,
    HackathonFooter,
    PartnersHackathon,
    TestimonialsHackathon,
    FaqHackathon,
  },
  data() {
    return {
      bdkLogo,
      ldkLogo,
      flashLogo,
      wdkLogo,
      blinkLogo,
      lnbitsLogo,
      albyLogo,
      fedimintLogo,
      cashuLogo,
      lnurlLogo,
      weblnLogo,
      nostrLogo,
      rgbLogo,
      bitnobLogo,
    }
  },
  mounted() {
    window.scrollTo(0, 0)
  },
}
</script>

<style scoped>
/* ── Hero ── */
.hackathon-hero {
  background:
    radial-gradient(ellipse at 0% 100%, rgba(66, 215, 134, 0.55) 0%, transparent 45%),
    radial-gradient(ellipse at 0% 100%, #F6F1E9 0%, transparent 20%),
    radial-gradient(ellipse 70% 90% at 100% 40%, rgba(66, 215, 134, 0.40) 0%, transparent 60%),
    radial-gradient(ellipse at 100% 100%, #F6F1E9 0%, transparent 30%),
    #f8f6f2;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 120px 64px 80px;
  min-height: 875px;
}

.hackathon-hero-content {
  text-align: center;
  width: 100%;
  max-width: 1000px;
}

/* ── Badge prize ── */
.hero-prize-badge {
  display: inline-flex;
  align-items: center;
  width: auto;
  max-width: 421px;
  height: 69px;
  gap: 13px;
  padding: 12px 20px;
  background: #E8E7E7;
  border-radius: 49px;
  margin-bottom: 32px;
  box-sizing: border-box;
}

.badge-pills {
  display: flex;
  align-items: center;
  width: 111px;
  height: 45px;
  flex-shrink: 0;
  position: relative;
}

.badge-pill {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  flex-shrink: 0;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 800;
}

.badge-pill:nth-child(2) { margin-left: -12px; z-index: 2; }
.badge-pill:nth-child(3) { margin-left: -12px; z-index: 3; }

.badge-pill--trophy {
  background: #FF9211;
  z-index: 1;
  font-size: 20px;
}

.badge-pill--btc {
  background: #FBDB6C;
  color: #05246A;
}

.badge-pill--lightning {
  background: #42D786;
  color: #05246A;
}

.badge-text {
  display: flex;
  align-items: center;
  font-family: 'DM Sans', sans-serif;
  font-size: 1.15rem;
  font-weight: 700;
  color: #0D2D6B;
  white-space: nowrap;
}

/* ── Titre ── */
.hero-title {
  font-family: 'DM Sans', sans-serif;
  font-weight: 700;
  font-size: 96px;
  line-height: 108.6px;
  letter-spacing: 0;
  margin: 0 0 20px;
}

.title-bitcoin  { color: #FF9211; }
.title-hackathon { color: #05246A; }

/* ── Hook ── */
.hero-hook {
  font-family: 'DM Sans', sans-serif;
  font-size: 36px;
  font-weight: 700;
  line-height: 69.11px;
  color: #05246A;
  text-align: center;
  width: 100%;
  max-width: 762px;
  margin: 0 auto 12px;
  white-space: nowrap;
}

/* ── Description ── */
.hero-desc {
  font-family: 'DM Sans', sans-serif;
  font-size: 24px;
  font-weight: 400;
  line-height: 33px;
  color: #05246A;
  text-align: center;
  width: 100%;
  max-width: 774px;
  margin: 0 auto 40px;
}

/* ── CTAs ── */
.hero-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-bottom: 56px;
  flex-wrap: wrap;
}

.btn-join {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 298px;
  height: 66px;
  background: #42D786;
  color: #05246A;
  font-family: 'DM Sans', sans-serif;
  font-weight: 700;
  font-size: 24px;
  line-height: 45.65px;
  border-radius: 16px;
  text-decoration: none;
  transition: opacity 0.2s, transform 0.15s;
}

.btn-join:hover {
  opacity: 0.88;
  transform: translateY(-1px);
}

.btn-date {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 320px;
  height: 66px;
  gap: 22.83px;
  padding: 9.13px 22.83px;
  border-radius: 16px;
  background: #FBDB6CE3;
  color: #05246A;
  font-family: 'DM Sans', sans-serif;
  font-weight: 500;
  font-size: 24px;
  line-height: 45.65px;
  box-sizing: border-box;
}

/* ── Stats card ── */
.hero-stats-card {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 844px;
  height: 111px;
  background: #FFFFFF;
  border-radius: 13px;
  padding: 8px 40px;
  box-sizing: border-box;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
}

.stats-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.78rem;
  font-weight: 600;
  color: #000000;
  white-space: nowrap;
  flex-shrink: 0;
}

.stats-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #FBDB6C;
  flex-shrink: 0;
}

.stats-divider {
  display: none;
}

.stats-items-group {
  display: flex;
  align-items: center;
  gap: 0;
  flex: 1;
  justify-content: space-around;
}

.stats-sep {
  width: 1px;
  height: 40px;
  background: rgba(0,0,0,0.12);
  flex-shrink: 0;
}

.stats-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.stats-number {
  font-family: 'DM Sans', sans-serif;
  font-size: 1.5rem;
  font-weight: 900;
  color: #0D2D6B;
  line-height: 1;
}

.stats-desc {
  font-size: 0.75rem;
  color: #000000;
  font-weight: 500;
}

.br-desktop { display: inline; }

/* ── Pourquoi participer ── */
.section-why {
  background: #F6F1E9;
  width: 100%;
  min-height: 810px;
  margin: 0 auto;
  display: flex;
  align-items: center;
}

.why-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 80px 64px;
  width: 100%;
}

.why-title {
  font-family: 'DM Sans', sans-serif;
  font-size: 2.2rem;
  font-weight: 700;
  color: #05246A;
  text-align: center;
  margin: 0 0 16px;
}

.why-subtitle {
  font-family: 'DM Sans', sans-serif;
  font-size: 1rem;
  font-weight: 400;
  color: #6B7280;
  text-align: center;
  margin: 0 0 56px;
  line-height: 1.5;
}

.why-grid {
  display: grid;
  grid-template-columns: repeat(4, 322px);
  gap: 20px;
  justify-content: center;
}

.why-card {
  width: 100%;
  height: 316px;
  border-radius: 24px;
  border: 1px solid #FFFFFF66;
  backdrop-filter: blur(4px);
  padding: 33px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.why-card--peach {
  background: linear-gradient(135deg, rgba(255, 146, 17, 0.2) 0%, rgba(255, 146, 17, 0.05) 100%);
}
.why-card--green {
  background: linear-gradient(135deg, rgba(66, 215, 134, 0.2) 0%, rgba(66, 215, 134, 0.05) 100%);
}
.why-card--cream {
  background: linear-gradient(135deg, rgba(251, 219, 108, 0.2) 0%, rgba(251, 219, 108, 0.05) 100%);
}
.why-card--orange {
  background: linear-gradient(135deg, rgba(255, 146, 17, 0.2) 0%, rgba(255, 146, 17, 0.05) 100%);
}

.why-icon-wrap {
  width: 80px;
  height: 80px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 32px;
  flex-shrink: 0;
}

.why-icon-wrap--peach {
  background: linear-gradient(135deg, rgba(255, 146, 17, 0.2) 0%, rgba(255, 146, 17, 0.1) 100%);
  border: 1px solid #FF921133;
}
.why-icon-wrap--green {
  background: linear-gradient(135deg, rgba(66, 215, 134, 0.2) 0%, rgba(66, 215, 134, 0) 100%);
  border: 1px solid #E2E8F0;
}
.why-icon-wrap--cream {
  background: linear-gradient(135deg, rgba(251, 219, 108, 0.2) 0%, rgba(251, 219, 108, 0.1) 100%);
  border: 1px solid #E2E8F0;
}
.why-icon-wrap--orange {
  background: linear-gradient(135deg, rgba(255, 146, 17, 0.2) 0%, rgba(255, 146, 17, 0.1) 100%);
  border: 1px solid #FF921133;
}

.why-card-title {
  font-family: 'DM Sans', sans-serif;
  font-size: 24px;
  font-weight: 700;
  line-height: 32px;
  color: #05246A;
  margin: 0 0 12px;
}

.why-card-desc {
  font-family: 'DM Sans', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #05246AB2;
  margin: 0;
}

/* ── Technologies Bitcoin ── */
.section-tech {
  width: 100%;
  min-height: 1036px;
  margin: 0 auto;
  background: #FFF0BD;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-bottom: 0;
  overflow: hidden;
}

.tech-container {
  max-width: 1600px;
  margin: 0 auto;
  padding: 71px 32px 0;
  width: 100%;
  box-sizing: border-box;
}

.tech-title {
  font-family: 'DM Sans', sans-serif;
  font-size: 36px;
  font-weight: 700;
  line-height: 69.11px;
  color: #05246A;
  margin: 0 0 8px 90px;
  text-align: left;
  max-width: 1200px;
  width: 100%;
}

.tech-subtitle {
  font-family: 'DM Sans', sans-serif;
  font-size: 24px;
  font-weight: 400;
  line-height: 33px;
  color: #05246A;
  margin: 0 0 48px 90px;
  text-align: left;
  max-width: 1200px;
  width: 100%;
}

.tech-card-header {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 20px;
}

.tech-logo {
  width: 65px;
  height: 65px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.tech-logo--bdk   { background: #FFF0E0; border-radius: 6px; }
.tech-logo--ldk   { background: #F3F4F6; border-radius: 3px; }
.tech-logo--flash { background: #1E3A8A; border-radius: 6px; }
.tech-logo--wdk   { background: #FFF0E0; border-radius: 6px; border: 1px solid #F97316; }
.tech-logo--blink { background: #111;    border-radius: 6px; }
.tech-logo--lnbits{ background: #7C3AED; border-radius: 3px; }

.tech-name {
  font-family: 'DM Sans', sans-serif;
  font-size: 24px;
  font-weight: 700;
  line-height: 32px;
  color: #05246A;
}

.tech-desc {
  position: absolute;
  top: 113px;
  left: 23px;
  width: 250px;
  height: 48px;
  font-family: 'DM Sans', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #05246A;
  margin: 0;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow-wrap: break-word;
}

.tech-link {
  position: absolute;
  top: 203px;
  left: 20px;
  width: 118.32px;
  height: 17px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #42D786;
  text-decoration: none;
}

.tech-link:hover { opacity: 0.8; }

/* ── Plus encore ── */
.tech-more {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.tech-more-title {
  font-family: 'DM Sans', sans-serif;
  font-size: 24px;
  font-weight: 700;
  line-height: 32px;
  color: #05246A;
  margin: 0 0 24px;
}

.tech-more-wrapper {
  position: relative;
  width: calc(100% - 98px);
  max-width: 1630px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.tech-more-wrapper .tech-badges {
  position: relative;
  z-index: 2;
  transform: translateY(50%);
  background: #FFF0BD;
  padding: 0 8px;
}

.tech-more-border {
  width: 100%;
  height: 83px;
  background-image:
    repeating-linear-gradient(90deg, rgba(0,0,0,0.73) 0, rgba(0,0,0,0.73) 5px, transparent 5px, transparent 10px),
    repeating-linear-gradient(0deg, rgba(0,0,0,0.73) 0, rgba(0,0,0,0.73) 5px, transparent 5px, transparent 10px),
    repeating-linear-gradient(0deg, rgba(0,0,0,0.73) 0, rgba(0,0,0,0.73) 5px, transparent 5px, transparent 10px);
  background-size:
    100% 1px,
    1px 100%,
    1px 100%;
  background-position:
    0 0,
    0 0,
    100% 0;
  background-repeat: no-repeat;
}

.tech-badges {
  display: flex;
  align-items: center;
  gap: 11px;
  flex-wrap: nowrap;
  justify-content: center;
  overflow: hidden;
}

.tech-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #FFFFFF;
  border-radius: 10px;
  height: 40px;
  padding: 0 12px;
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
}

.badge-icon {
  width: 20px;
  height: 20px;
  border-radius: 5px;
  flex-shrink: 0;
  object-fit: contain;
}

/* ── Prizes ── */
.section-prizes {
  width: 100%;
  min-height: 810px;
  margin: 0 auto;
  background: #F5F0E8;
  display: flex;
  align-items: center;
}

.prizes-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 80px 64px;
  width: 100%;
}

.prizes-title {
  font-family: 'DM Sans', sans-serif;
  font-size: 2.2rem;
  font-weight: 700;
  color: #05246A;
  text-align: center;
  margin: 0 0 12px;
}

.prizes-title--orange { color: #FF9211; }

.prizes-subtitle {
  font-size: 1rem;
  color: #6B7280;
  text-align: center;
  margin: 0 0 40px;
  line-height: 1.6;
}

.prizes-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-bottom: 48px;
}

.prize-card {
  background: #fff;
  border-radius: 20px;
  padding: 28px 24px;
  position: relative;
}

.prize-badge-top {
  position: absolute;
  top: -14px;
  left: 20px;
  background: #FF9211;
  color: #fff;
  font-size: 0.72rem;
  font-weight: 700;
  padding: 4px 12px;
  border-radius: 99px;
}

.prize-icon {
  width: 52px;
  height: 52px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}

.prize-icon--gold   { background: linear-gradient(135deg, #F97316, #FBBF24); }
.prize-icon--green  { background: #42D786; }
.prize-icon--yellow { background: linear-gradient(135deg, #FBBF24, #F59E0B); }
.prize-icon--dark   { background: #1E1B4B; }

.prize-name {
  font-family: 'DM Sans', sans-serif;
  font-size: 1.05rem;
  font-weight: 700;
  color: #05246A;
  margin: 0 0 8px;
}

.prize-award {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.85rem;
  color: #6B7280;
  margin: 0 0 16px;
}

.prize-award--gray { color: #9CA3AF; }

.prize-award-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.prize-award-dot--orange { background: #F97316; }
.prize-award-dot--green  { background: #42D786; }
.prize-award-dot--yellow { background: #FBBF24; }

.prize-amount {
  font-family: 'DM Sans', sans-serif;
  font-size: 1.3rem;
  font-weight: 800;
  margin: 0;
}

.prize-amount--orange { color: #FF9211; }
.prize-amount--green  { color: #42D786; }
.prize-amount--yellow { color: #F59E0B; }
.prize-amount--dark   { color: #05246A; }

.prizes-more-title {
  font-family: 'DM Sans', sans-serif;
  font-size: 1.5rem;
  font-weight: 700;
  color: #FF9211;
  text-align: center;
  margin: 0 0 8px;
}

.prizes-more-sub {
  font-family: 'DM Sans', sans-serif;
  font-size: 24px;
  font-weight: 400;
  line-height: 33px;
  letter-spacing: 0%;
  color: #05246A;
  text-align: center;
  margin: 0 0 24px;
}

.prizes-bonus-card {
  background: #E8F5EE;
  border-radius: 16px;
  padding: 24px 32px;
  display: flex;
  flex-wrap: wrap;
  gap: 12px 40px;
  justify-content: center;
}

.bonus-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.88rem;
  color: #374151;
}

.bonus-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #FF9211;
  flex-shrink: 0;
}

/* ── Agenda ── */
.section-agenda {
  width: 100%;
  min-height: 810px;
  margin: 0 auto;
  background: #fff;
  display: flex;
  align-items: center;
}

.agenda-container {
  width: 100%;
  margin: 0 auto;
  padding: 80px 0;
  box-sizing: border-box;
}

.agenda-title {
  font-family: 'DM Sans', sans-serif;
  font-size: 2.2rem;
  font-weight: 700;
  color: #05246A;
  text-align: center;
  margin: 0 0 12px;
}

.agenda-title--orange { color: #FF9211; }

.agenda-subtitle {
  font-family: 'DM Sans', sans-serif;
  font-size: 24px;
  font-weight: 400;
  color: #05246A;
  text-align: center;
  width: 602px;
  height: 33px;
  margin: 0 auto 56px;
}

.agenda-grid {
  display: grid;
  grid-template-columns: 418px 346px 461px;
  margin-bottom: 56px;
  gap: 0;
  justify-content: center;
  width: 1408px;
  max-width: calc(100% - 80px);
  margin-left: auto;
  margin-right: auto;
  position: relative;
}

.agenda-grid::before,
.agenda-grid::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  height: 0;
  border-top: 1px dashed rgba(0,0,0,0.5);
  border-image: repeating-linear-gradient(90deg, rgba(0,0,0,0.5) 0, rgba(0,0,0,0.5) 3px, transparent 3px, transparent 6px) 1;
}

.agenda-grid::before { top: 0; }
.agenda-grid::after  { bottom: 0; }

.agenda-col { padding: 36px 32px; }

.agenda-col--border {
  position: relative;
}

.agenda-col--border::before {
  content: '';
  position: absolute;
  left: -1px;
  top: -50px;
  height: calc(100% + 50px);
  width: 0;
  border-left: 1px dashed rgba(0,0,0,0.5);
  border-image: repeating-linear-gradient(180deg, rgba(0,0,0,0.5) 0, rgba(0,0,0,0.5) 3px, transparent 3px, transparent 6px) 1;
}

.agenda-day-badge {
  font-size: 0.82rem;
  font-weight: 700;
  margin-bottom: 10px;
}

.agenda-day-badge--yellow { color: #F59E0B; }
.agenda-day-badge--green  { color: #42D786; }
.agenda-day-badge--orange { color: #F97316; }

.agenda-day-heading {
  font-family: 'DM Sans', sans-serif;
  font-size: 1.5rem;
  font-weight: 700;
  color: #05246A;
  margin-bottom: 6px;
}

.agenda-day-heading span { margin-left: 8px; }

.agenda-day-sub {
  font-size: 0.88rem;
  color: #6B7280;
  margin: 0 0 24px;
}

.agenda-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.agenda-list li {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.9rem;
  color: #374151;
}

.agenda-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.agenda-dot--green  { background: #42D786; }
.agenda-dot--yellow { background: #F59E0B; }
.agenda-dot--orange { background: #F97316; }

.agenda-cta-wrap { text-align: center; }

.agenda-cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #42D786;
  color: #000;
  font-family: 'DM Sans', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  padding: 18px 48px;
  border-radius: 14px;
  text-decoration: none;
  transition: opacity 0.2s;
}

.agenda-cta:hover { opacity: 0.88; }

/* ── Animations ── */
.animation-section { margin: 0; }

/* ── Responsive ── */

/* Tablette large */
@media (max-width: 1200px) {
  .why-grid { grid-template-columns: repeat(2, 1fr); }
  .why-card { height: auto; }
  .tech-title { margin-left: 32px; }
  .tech-subtitle { margin-left: 32px; }
  .tech-grid { grid-template-columns: repeat(2, 1fr) !important; width: 100% !important; }
  .tech-card { width: 100% !important; max-width: 100% !important; }
  .prizes-grid { grid-template-columns: repeat(2, 1fr); }
  .agenda-grid { grid-template-columns: 1fr 1fr; width: 100%; max-width: 100%; }
}

/* Tablette */
@media (max-width: 1024px) {
  .hackathon-hero { padding: 110px 40px 70px; }
  .hero-title { font-size: 72px; line-height: 82px; }
  .hero-hook { font-size: 28px; white-space: normal; width: 100%; }
  .hero-desc { font-size: 18px; width: 100%; }
  .hero-stats-card { width: 100%; gap: 24px; }
  .tech-container { padding: 60px 32px 0; }
  .tech-title { font-size: 28px; line-height: 1.3; margin-left: 0; }
  .tech-subtitle { font-size: 18px; margin-left: 0; }
  .why-container, .prizes-container { padding: 64px 40px; }
  .agenda-container { padding: 64px 40px; }
  .agenda-grid { grid-template-columns: 1fr 1fr; width: 100%; max-width: 100%; }
}

/* Mobile */
@media (max-width: 768px) {
  /* Hero */
  .hackathon-hero { padding: 100px 20px 56px; min-height: auto; }
  .hero-prize-badge { height: auto; padding: 10px 16px; max-width: 100%; }
  .badge-text { font-size: 0.95rem; }
  .hero-title { font-size: 48px; line-height: 56px; }
  .hero-hook { font-size: 22px; line-height: 1.4; white-space: normal; width: 100%; }
  .hero-desc { font-size: 16px; line-height: 1.5; width: 100%; }
  .br-desktop { display: none; }
  .hero-actions { flex-direction: column; align-items: stretch; gap: 12px; }
  .btn-join, .btn-date { width: 100%; font-size: 18px; height: 56px; }
  .hero-stats-card {
    width: 100%;
    height: auto;
    padding: 20px 16px 20px;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
  .stats-divider { display: none; }
  .stats-items-group {
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: 100%;
    gap: 16px;
  }
  .stats-sep { display: none; }
  .stats-item { align-items: flex-start; }

  /* Sections */
  .section-why, .section-prizes, .section-agenda, .section-tech { min-height: auto; }
  .why-container, .prizes-container, .agenda-container { padding: 48px 20px; }
  .why-grid { grid-template-columns: 1fr; }
  .why-card { height: auto; }

  /* Tech */
  .tech-container { padding: 48px 20px 0; }
  .tech-title { font-size: 24px; line-height: 1.3; margin: 0 0 8px; }
  .tech-subtitle { font-size: 16px; margin: 0 0 32px; }
  .tech-grid { grid-template-columns: 1fr !important; width: 100% !important; }
  .tech-card { width: 100% !important; max-width: 100% !important; height: auto !important; }
  .tech-desc { position: static !important; width: 100% !important; height: auto !important; margin: 0 0 16px !important; -webkit-line-clamp: unset !important; line-clamp: unset !important; }
  .tech-link { position: static !important; height: auto !important; }
  .tech-more-wrapper { width: 100%; }
  .tech-badges { flex-wrap: wrap; gap: 8px; }

  /* Prizes */
  .prizes-grid { grid-template-columns: 1fr 1fr; gap: 16px; }
  .prizes-container { padding: 48px 20px; }

  /* Agenda */
  .agenda-grid { grid-template-columns: 1fr; width: 100%; max-width: 100%; }
  .agenda-grid::before, .agenda-grid::after { display: none; }
  .agenda-col--border::before { display: none; }
  .agenda-col--border { border-top: 1px dashed rgba(0,0,0,0.3); padding-top: 32px; }
  .agenda-subtitle { width: 100%; height: auto; }
  .agenda-cta { width: 100%; text-align: center; }
}

/* Petit mobile */
@media (max-width: 480px) {
  .hero-title { font-size: 38px; line-height: 46px; }
  .badge-pills { width: 80px; }
  .badge-pill { width: 36px; height: 36px; font-size: 14px; }
  .prizes-grid { grid-template-columns: 1fr; }
  .prize-card { padding: 24px 20px; }
  .why-container, .prizes-container, .agenda-container { padding: 40px 16px; }
  .tech-container { padding: 40px 16px 0; }
  .stat-number { font-size: 1.2rem; }
  .prizes-bonus-card { padding: 20px; gap: 10px 20px; }
}
</style>